import { ApiError } from '@/lib/api'

/**
 * The "Passwort ändern" dialog's rules and its error wording.
 *
 * Pure, because the interesting parts are invisible from the screen: what
 * the gateway means by each status, and that its 400 body is a gin binding
 * message in English (`Key: 'NewPassword' Error:Field validation ... 'min'`)
 * which must never reach a user.
 *
 * `POST /v1/auth/change-password` (`api/internal/api/auth_handlers.go`)
 * answers 401 for a wrong *current* password — the same status the API
 * client treats as an expired token. The client refreshes and retries once,
 * the retry 401s again and the error is handed back here, so a mistyped
 * password costs one extra refresh round-trip but never signs anybody out.
 */
export const MIN_PASSWORD_LENGTH = 8

/** Client-side check, so the obvious mistakes cost no round-trip. */
export function validatePasswordChange(next: string, confirm: string): string | null {
  if (next.length < MIN_PASSWORD_LENGTH)
    return `Das neue Passwort muss mindestens ${MIN_PASSWORD_LENGTH} Zeichen haben.`
  if (next !== confirm) return 'Die beiden Passwörter stimmen nicht überein.'
  return null
}

export function changePasswordErrorMessage(error: unknown): string {
  const api = ApiError.from(error)
  if (api.code === 'network_error') return 'Keine Verbindung zum Server. Bitte später erneut versuchen.'
  switch (api.status) {
    case 401:
      return 'Das aktuelle Passwort ist falsch.'
    case 400:
      // The only field the gateway validates is the new password's length.
      return `Das neue Passwort muss mindestens ${MIN_PASSWORD_LENGTH} Zeichen haben.`
    case 503:
      return 'Die Anmeldung ist gerade nicht verfügbar. Bitte später erneut versuchen.'
    default:
      return 'Das Passwort konnte nicht geändert werden. Bitte später erneut versuchen.'
  }
}
